import { github } from 'react-code-blocks';
import styled from 'styled-components';

import { Text } from '@atom/typography/typography';

const customStyleCodeBlock = {
  maxHeight: '480px',
  overflowY: 'auto',
  overflowX: 'auto',
  borderRadius: '5px',
  fontSize: '0.75rem',
  padding: '8px 0',
  marginLeft: '-16px',
};

export const themeCodeBlock = {
  theme: { ...github, backgroundColor: 'transparent' },
  showLineNumbers: true,
  wrapLines: true,
  codeBlock: true,
  customStyle: customStyleCodeBlock,
};

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ResponseTypeTitle = styled(Text)`
  display: block;
  text-align: right;
`;
